const PHRASES = [
  "abundance is a language",
  "the cycle ends with you",
  "your words become her inner voice",
  "before age five",
  "warm, calm boundaries",
  "it is very fixable",
];

export const Marquee = () => {
  const items = [...PHRASES, ...PHRASES];
  return (
    <div data-testid="editorial-marquee" className="overflow-hidden border-y border-[#E6DEC3] bg-[#F4EFE6] py-5 select-none">
      <div className="marquee-track flex whitespace-nowrap w-max">
        {[0, 1].map((half) => (
          <div key={half} className="flex shrink-0">
            {items.map((p, i) => (
              <span key={`${half}-${i}`} className="flex items-center">
                <span className="font-serif-display italic text-xl sm:text-2xl text-[#8C4A32]/50 px-6">{p}</span>
                <span className="w-1.5 h-1.5 rounded-full bg-[#C69C6D]/60" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
